/***
 * TODO:  Where to start : figure out how the bookmarks subfeeds are working.
 *  First thing to do is to deal with the ViewForums -- make sure it is sending the sensible stuff to back end
 *   -- get the data sent back correctly. (Parse the array and send it)
 *  Get them to load properly, and to have a sensible note if there is nothing bookmarked
 *  Make sure the conglomerations are sensible (Add the forums)
 *  Make sure that we re-filter everything when we add a bookmark to the feed.  That will be tricky, yo.  Prolly
 *   just run the filter again?
 */

/* Views used in the Feed  */

AoPS.Feed = AoPS.Feed || {};

AoPS.Feed.Views = (function (FeedViews) {
	var Lang = AoPS.Community.Lang,
		Utils = AoPS.Community.Utils,
		Flyout = AoPS.Ui.Flyout;

	/**
	 * When a topic is read anywhere in the community, we need to check if
	 *  if we can turn off the "unread topic in this list" light on the
	 *  corresponding feed button.  This function performs the check.
	 *  The listeners that call this check are built where the subfeeds are built.
	 *
	 * @param object
	 *		topic : AoPS.Community.Models.Topic of the read topic
	 *		$button : JQuery of the feed button for this subfeed
	 *		list : Collection of Models.Topic for this feed
	 **/
	FeedViews.processFeedTopicIsReadChange = function (obj) {
		// Topic is not read; don't have to worry about list being fully read.
		//  The topic add watcher takes care of turning the light on for this subfeed.
		if (!obj.topic.get("is_read")) {
			return;
		}

		/**
		 * List already marked read; don't have to check.
		 */
		if (!obj.$button.hasClass("feed-subfeed-new-topic")) {
			return;
		}
		FeedViews.checkSubfeedUnread(obj);
	};

	/**
	 * Check if we should mark a subfeed read or not.
	 * @param object
	 *		$button : JQuery of the feed button for this subfeed
	 *		list : Collection of Models.Topic for this feed
	 **/
	FeedViews.checkSubfeedUnread = function (obj) {
		/**
		 * If the list is long, we are going to skip this check.
		 **/
		if (
			obj.list.length > AoPS.Community.Constants.max_length_feed_list_read_check
		) {
			return;
		}

		var unread_topic = obj.list.findWhere({is_read: false});

		/**
		 * If there are none unread, turn off "new-topic".
		 **/
		if (_.isUndefined(unread_topic)) {
			obj.$button.removeClass("feed-subfeed-new-topic");
		} else if (obj.list.length > 0) {
			obj.$button.addClass("feed-subfeed-new-topic");
		}
	};

	/***
	 * FeedMaster is the view for the whole feed.
	 *
	 * model : AoPS.Community.Models.Feed
	 *
	 * Properties
	 * active_subfeed object: describes the subfeed that is currently open (null for none)
	 * active_topic_view FeedViews.TopicFull for the topic that is currently open in the feed.
	 * animate_speed int: governs how quickly the panel opens
	 * feed_open boolean: tells whether or not the feed is open
	 * subfeeds array of objects that describe the subfeeds
	 * $topic : Div that holds full topics.
	 * topic_views array of FeedViews.TopicFull that have been built for the feed
	 *
	 *
	 * Methods
	 *
	 * constructSubfeeds()
	 *  	Build the subfeeds used in the feed
	 *
	 * addSubfeed(obj)
	 *		Construct a single subfeed.
	 *
	 * onButtonClick(subfeed)
	 *		What we do when we click on a particular subfeed
	 *
	 * closeSubfeed(subfeed)
	 *   	Close a particular subfeed
	 *
	 * activateSubfeed(subfeed, speed)
	 *		Open a particular subfeed.
	 *
	 * openFeed(subfeed)
	 *  	Open the feed window with a particular subfeed.
	 *
	 * closeFeed()
	 *		Close the whole feed window.
	 *
	 * constructBookmarksSubfeed()
	 *		Build the subfeed for the bookmarks categories
	 *
	 * buildTopic()
	 * 		Build the current feed focus topic in the topic window
	 */
	FeedViews.FeedMaster = AoPS.View.extend({
		template_id: "#feed-master-tpl",

		feed_open: false,

		animate_speed: 200, // Don't go much higher, or we'll have to build
		// something to deal with users who click twice quickly in succession on the
		// "Show conversations attached to this item" icons; the feed is only
		//  closed out at the end of the animation.

		active_subfeed: null,

		active_topic_view: null,

		id: "feed-wrapper",

		topic_views: [],

		subfeeds: [],

		has_page_feed: false,

		cached_page_subfeed_views: {},

		initialize: function () {
			// if this is a free trial enrollment, hide the embedded forum
			if (AoPS.bd.is_free_trial_enrollment) {
				return;
			}
			var self = this;
			this.$el.html(this.getTemplate(this.template_id, {}));

			/** Set object variables to feed window components **/
			this.$tabs = this.$el.find("#feed-tabs");

			this.$topics_list = this.$el.find("#feed-topic-list");
			this.$topic = this.$el.find("#feed-topic");
			this.$topic_loader = AoPS.Page.buildLoader();

			this.$el.on("mousedown", function (e) {
				e.stopPropagation();
			});

			/**
			 * Whenever we mousedown outside the feed, we want the current topic
			 *  to close.  (We can't use click, or the event that catches the
			 *  mousedown on the feed (just above) will eat clicks on links in
			 *  the feed.)
			 *
			 * However, there's one special case -- if we are clicking on the open feed icon.
			 *  Here, if there's a topic open, and it is the topic that the open feed icon
			 *  will open (say, on Alcumus or on WOOT POTD), then we want to close
			 *  the topic and the feed.  So, we catch the old topic id in the mousedown listener
			 *  on the body (search for mousedown.feed or click.feed), and check that value against
			 *  the sought topic.
			 **/
			self.past_topic_id = 0;
			$("body").on("click.feed", function (e) {
				self.past_topic_id = 0;
			});
			this.feed_animated = false;
			this.community_master = this.model.get("master");
			this.model = this.community_master.get("feed");
			this.constructSubfeeds();
			this.listenTo(this.model, "change:focus_topic", this.buildTopic);

			this.listenTo(
				this.community_master.get("current_user"),
				"change:show_tags_on_feed",
				this.processShowTags
			);
			this.processShowTags();
			this.listenTo(
				this.model,
				"change:page_subfeed_settings",
				this.onNewPageSubfeed
			);
			this.listenTo(
				this.community_master,
				"change:fullscreen_mode",
				function (model) {
					if (self.community_master.previous("fullscreen_mode") === "feed") {
						self.offFullscreen();
					} else if (self.community_master.get("fullscreen_mode") === "feed") {
						self.onFullscreen();
					}
				}
			);
			/*this.listenTo(this.model, 'feed-fullscreen-off', function () {
				self.offFullScreen();
			});//this.offFullscreen);
			*/
			this.setVisibility();
			if (AoPS.session.logged_in_and_initialized) {
				this.listenTo(
					this.community_master.get("current_user"),
					"change:hide_feed",
					this.setVisibility
				);
			}

			if (this.community_master.get("current_user").get("hide_avatars")) {
				this.$el.addClass("cmty-hide-avatars");
			}
			this.listenTo(
				this.community_master.get("current_user"),
				"change:hide_avatars",
				function () {
					self.$el.toggleClass(
						"cmty-hide-avatars",
						self.community_master.get("current_user")
					);
				}
			);

			this.listenTo(Backbone, "community_disabled", this.onCommunityDisabled);
			this.listenTo(Backbone, "close_feed_topic", this.onTriggerCloseFeedTopic);

			Utils.startIdleMonitor();
			Utils.activateLatexOnclick();
		},

		events: {
			"click .feed-subfeed-header": "closeFeed",
			"click .feed-resort": "onClickResort",
		},

		onCommunityDisabled: function () {
			Flyout.display(Lang["feed-community-disabled"]);
			this.hideFeed();
		},

		onFullscreen: function () {
			this.$topic.left_css = this.$topic.is_dragged
				? this.$topic.css("left")
				: "";
			this.$topic.top_css = this.$topic.is_dragged
				? this.$topic.css("top")
				: "";

			this.$topic.css({
				left: "",
				top: "",
			});
			this.$topic.draggable("disable");
		},

		offFullscreen: function () {
			this.$topic.css({
				left: this.$topic.left_css,
				top: this.$topic.top_css,
			});
			this.$topic.draggable("enable");
		},

		setVisibility: function () {
			if (
				AoPS.session.logged_in &&
				AoPS.session.initialized &&
				Number(this.community_master.get("current_user").get("hide_feed")) === 1
			) {
				this.hideFeed();
			} else {
				this.showFeed();
			}
		},

		processShowTags: function () {
			this.$el.toggleClass(
				"cmty-show-feed-tags",
				this.community_master.get("current_user").get("show_tags_on_feed")
			);
		},

		hideFeed: function () {
			this.$el.addClass("feed-hidden");
		},

		showFeed: function () {
			if (AoPS.Community.is_active) {
				this.$el.removeClass("feed-hidden");
			}
		},

		onTriggerCloseFeedTopic: function () {
			this.model.set("focus_topic", null);
			if (this.community_master.get("fullscreen_mode") === "feed") {
				this.community_master.set("fullscreen_mode", "none");
				$(window).trigger("resize");
			}
		},

		/**
		 * Constructing subfeeds consists of making the corresponding
		 *  button for the subfeed and building the subview for that subfeed.
		 */
		constructSubfeeds: function () {
			var private_category,
				ajax_data = [],
				view,
				i;
			this.global_subfeed = this.addSubfeed({
				header_text: Lang["feed-global-subfeed-header"],
				id: "feed-global-tab",
				title:
					this.model.get("global_feed_type") === "full"
						? Lang["feed-tab-global-title"]
						: Lang["feed-tab-global-custom-title"],
				icon_letter: "a",
				category: new AoPS.Community.Models.CategoryGlobal({
					master: this.community_master,
				}),
			});

			if (AoPS.session.logged_in_and_initialized) {
				this.addSubfeed({
					header_text: Lang["feed-ego-subfeed-header"],
					id: "feed-egosearch-tab",
					title: Lang["feed-tab-my-topics-title"],
					icon_letter: "w",
					category: new AoPS.Community.Models.CategoryUsersTopics({
						master: this.community_master,
						user_id: AoPS.session.user_id,
					}),
				});

				private_category = this.community_master.fetchCategory(1);
				// Only moderately tested
				this.addSubfeed({
					header_text: Lang["feed-messages-subfeed-header"],
					id: "feed-privates-tab",
					title: Lang["feed-tab-private-title"],
					icon_letter: "m",
					can_post: true,
					can_post_title: Lang["feed-new-private-conversation"],
					category: private_category,
					onClickNewTopic: _.bind(function () {
						if (
							!private_category.getPermission("c_can_start_topic") &&
							!private_category.getPermission("c_undo_global_ban")
						) {
							AoPS.Ui.Modal.showMessage(
								Lang[
									AoPS.isUserLimited()
										? "new-pm-no-permission-limited"
										: "new-pm-no-permission"
								],
								{
									width: "450px",
								}
							);
						} else {
							this.launchNewPrivate();
						}
						// TODO: reroute to the topic in the feed after posting,
						//  not to the browser route.  That will be a bear.
						// We probably will have to split the onClickLaunchNewTopic in two in CategoryCellMyPrivates.
					}, this),
				});

				this.constructBookmarksSubfeed();
			}

			/**
			 * Here's where we go get the initial topics for the subfeeds.
			 */
			for (i = 0; i < this.subfeeds.length; i++) {
				view = this.subfeeds[i].view.topics_list_view;
				ajax_data.push(
					view.collection.constructAjaxCall(
						view.constructFetchMoreTopicsOptions()
					)
				);
			}
			if (this.hasOwnProperty("bookmark_subfeed")) {
				view = this.bookmark_subfeed.view.active_subfeed.topics_list_view;
				ajax_data.push(
					view.collection.constructAjaxCall(
						view.constructFetchMoreTopicsOptions()
					)
				);
			}
			this.model.fetchInitialSubfeedTopics(ajax_data);
		},

		launchNewPrivate: function () {
			var private_category = this.community_master.fetchCategory(1);
			// eslint-disable-next-line no-new
			new FeedViews.NewPrivateConversation({
				// TODO : Improve this!
				category_name: "", // PROBABLY put all of these in NewPrivateConversation as defaults.
				category_id: 1,
				model: private_category,
				master: this.community_master,
			});
		},

		/**
		 * Remove the listeners for a subfeed's view.
		 *
		 * @param object : member of subfeeds whose view needs to stop listening to its filtered_list
		 **/
		removeSubfeedListeners: function (subfeed) {
			subfeed.view.stopListening(subfeed.view.filtered_list);
		},

		/**
		 * Add listeners to a subfeed's view.
		 *
		 * @param object : member of subfeeds whose view needs to listen to events on its filtered_list
		 **/
		addSubfeedListeners: function (subfeed) {
			var self = this;
			// no listeners for dummy subfeeds, like the page loader
			if (!subfeed.view.hasOwnProperty("filtered_list")) {
				return;
			}
			/**
			 * This is how we decide to make the button glow if there's a new topic in this
			 *  subfeed.  This takes care of all but the bookmarks.
			 **/
			subfeed.view.listenTo(
				subfeed.view.filtered_list,
				"add",
				function (topic) {
					if (self.active_subfeed === subfeed) {
						return;
					}

					if (!topic.get("is_read")) {
						subfeed.$button.addClass("feed-subfeed-new-topic");
					}
				}
			);

			subfeed.view.listenTo(
				subfeed.view.filtered_list,
				"change:is_read",
				function (topic) {
					AoPS.Feed.Views.processFeedTopicIsReadChange({
						topic: topic,
						list: subfeed.view.filtered_list,
						$button: subfeed.$button,
					});
				}
			);
		},
		/**
		 * Create a single subfeed by adding its button
		 *  to the $tabs window and creating the topics_list
		 *  view for that subfeed.
		 *
		 * @param object with the following properties
		 *     header_text string : name of the subfeed on screen
		 *     id string: (dom id of this button's tab)
		 *     icon_letter char: Once we have the AoPS font, this is the letter that maps to the
		 *			subfeed's icon
		 *     category AoPS.Community.Models.Category (or extension) of the
		 *              category for this subfeed.
		 */
		addSubfeed: function (obj) {
			var subfeed = {
					$button: $("<div>", {
						id: obj.id,
						class: "feed-tab aops-font",
						text: obj.icon_letter,
						title: obj.title,
					}),
					view: {},
				},
				self = this;

			this.$tabs.append(subfeed.$button);

			subfeed.view = new FeedViews.Subfeed(
				_.defaults(
					{
						model: obj.category,
					},
					obj
				)
			);

			subfeed.$button.on("click", function () {
				self.onButtonClick(subfeed);
			});

			this.addSubfeedListeners(subfeed);

			this.subfeeds.push(subfeed);
			return subfeed;
		},

		/**
		 * What we do when we click on a particular feed tab.
		 *
		 * @param object : one of the subfeed objects in the subfeeds array
		 */
		onButtonClick: function (subfeed) {
			// The initial feed fetch always happens right away, but if the user
			//  is too quick to click on the feed, there won't be anything there.
			// So, we don't let those clicks do anything right away.  This will
			//  very rarely happen, so should be fine.  By the time the user clicks
			//  a second time, the data will be there.
			// We can do something smarter if we decide to care.
			if (!this.model.get("initialized")) {
				return;
			}

			// While the feed is moving, we set feed_animated to true to prevent double-click
			//  breakage.
			if (this.feed_animated) {
				return;
			}
			if (this.feed_open) {
				if (this.active_subfeed === subfeed) {
					this.closeFeed();
				} else {
					this.closeSubfeed(this.active_subfeed);
					this.activateSubfeed(subfeed, 0);
				}
			} else {
				this.openFeed(subfeed);
			}
		},

		/**
		 * Close a subfeed.
		 *
		 * @param object : member of subfeeds array to close.
		 */
		closeSubfeed: function (subfeed) {
			if (!subfeed) {
				return;
			}
			this.stopListening(Backbone, "topic_cell_marked_for_deletion");
			subfeed.view.$el.detach();

			if (subfeed.view.hasOwnProperty("topics_list_view")) {
				if (
					typeof subfeed.view.topics_list_view.processUpdatedTopicVisibility ===
					"function"
				) {
					subfeed.view.topics_list_view.processUpdatedTopicVisibility();
				}
				subfeed.view.topics_list_view.on_page = false;
			}
			subfeed.view.$(".feed-resort").hide();

			/**
			 * This must be called before onRemoveFromFeed,
			 *  because RemoveFromFeed removes the listeners that will
			 *  catch the focus_topic reset.
			 **/
			this.model.set("focus_topic", null);
			/**
			 * Get rid of the old feed topic, if there is one.
			 */
			if (!_.isNull(this.active_topic_view)) {
				this.active_topic_view.onRemoveFromFeed();
				this.active_topic_view = null;
			}
			subfeed.$button.removeClass("feed-subfeed-button-selected"); //, this.animate_speed); //HHHH
		},

		/**
		 * Activate a subfeed.
		 *
		 * @param object : member of subfeeds array to activate
		 * @param int : speed for window to open (may remove)
		 */
		activateSubfeed: function (subfeed, speed) {
			if (!subfeed || subfeed === this.active_subfeed) {
				return;
			}
			var self = this;
			// If the to-be-activated subfeed is currently having its topics loaded,
			//  then we do not want to cancel the ajax queue.
			if (
				!_.isUndefined(subfeed.view.topics_list_view) &&
				!_.isUndefined(subfeed.view.topics_list_view.collection) &&
				(_.isUndefined(
					subfeed.view.topics_list_view.collection.topics_loading
				) ||
					!subfeed.view.topics_list_view.collection.topics_loading)
			) {
				AoPS.Community.Utils.cmty_ajax.cancelAll({cancel_type: "feed"});
			}

			this.revealSubfeedView(subfeed);
			if (!_.isNull(this.active_subfeed)) {
				if (this.active_subfeed.$button !== subfeed.$button) {
					// active subfeed has been viewed; remove the new-topic marker until
					//  a new topic comes in
					this.active_subfeed.$button.removeClass("feed-subfeed-new-topic");
					subfeed.$button.addClass("feed-subfeed-button-selected"); //, speed);//HHHH
				}
			} else {
				subfeed.$button.addClass("feed-subfeed-button-selected"); //, speed);//HHHH
			}

			this.active_subfeed = subfeed;

			// We might instead choose only to build the listener once,
			//  And let it fire even when the feed isn't open. For now,
			//  I'll stick with this OCD approach.  If we take it away,
			//  we need to pull the stopListening out of closeSubfeed()
			this.topic_cell_delete_listener = this.listenTo(
				Backbone,
				"topic_cell_marked_for_deletion",
				function (obj) {
					if (self.active_subfeed.view.topics_list_view === obj.topics_list) {
						self.active_subfeed.view.$(".feed-resort").show();
					}
				}
			);
		},

		/**
		 * Show the view associated with a subfeed, and check if more topics are needed.
		 *
		 * @param object : member of subfeeds array whose view we want to show.
		 */
		revealSubfeedView: function (subfeed) {
			this.$topics_list.append(subfeed.view.$el);

			if (
				subfeed.view.hasOwnProperty("topics_list_view") &&
				typeof subfeed.view.topics_list_view.onAddToFeed === "function"
			) {
				subfeed.view.topics_list_view.onAddToFeed();
			}
		},

		/**
		 * Open the feed window with a particular subfeed open.
		 */
		openFeed: function (subfeed) {
			var self = this;
			if (this.feed_animated) {
				return;
			}
			this.activateSubfeed(subfeed, this.animate_speed);
			this.feed_animated = true;
			self.feed_open = true; // Tuck this back in the animate if you want to try to call buildTopic later
			this.$el.addClass("feed-open", {
				duration: this.animate_speed,
				complete: function () {
					self.feed_animated = false;
					// RR left this here to remind him how to do this when we change our minds
					//	self.buildTopic();
				},
			});
		},

		/**
		 * Close the feed window.
		 */
		closeFeed: function () {
			var self = this;
			if (this.feed_animated) {
				return;
			}
			AoPS.Community.Utils.cmty_ajax.cancelAll({cancel_type: "feed"});

			if (!_.isNull(this.active_subfeed)) {
				this.active_subfeed.$button.removeClass("feed-subfeed-button-selected"); //, this.animate_speed); //HHHH
			}
			this.feed_animated = true;
			this.$el.removeClass(
				"feed-open",
				this.animate_speed,
				"swing",
				_.bind(function () {
					if (!_.isNull(this.active_subfeed)) {
						this.closeSubfeed(this.active_subfeed);
						this.active_subfeed = null;
						self.feed_animated = false;
					}
				}, this)
			);
			/** This triggers closing topic. **/
			this.model.set("focus_topic", null);
			this.feed_open = false;
		},

		onClickResort: function (e) {
			this.resortActiveSubfeed();
			$(e.currentTarget).hide();
			e.stopPropagation();
			e.preventDefault();
		},

		resortActiveSubfeed: function () {
			if (!_.isNull(this.active_subfeed)) {
				this.active_subfeed.view.topics_list_view.processUpdatedTopicVisibility();
				this.active_subfeed.view.topics_list_view.setPopoutVisibility();
			}
		},

		/**
		 * Construct the bookmarks subfeed.
		 */
		constructBookmarksSubfeed: function () {
			var subfeed = {
				$button: $("<div>", {
					id: "feed-bookmark-tab",
					text: "E",
					title: Lang["feed-tab-bookmark-title"],
					class: "feed-tab aops-font",
				}),
				name: "bookmarks",
				view: {},
			};

			subfeed.view = new FeedViews.Bookmarks({
				model: this.model,
				feed_view: this,
				parent_subfeed_object: subfeed,
			});

			this.$tabs.append(subfeed.$button);

			subfeed.$button.on(
				"click",
				_.bind(function () {
					this.onButtonClick(subfeed);
				}, this)
			);

			this.bookmark_subfeed = subfeed;
		},

		/**
		 * The topic detaches itself from the DOM.  Here, we call the function that
		 *  deals with the clean-up when a topic is removed.
		 **/
		closeActiveTopicView: function () {
			this.active_topic_view.onRemoveFromFeed();
			this.active_topic_view.$el.detach();
			this.active_topic_view = null;
		},

		cleanTopicWindow: function () {
			var had_old_topic = !_.isNull(this.active_topic_view),
				topic = this.model.get("focus_topic");
			this.$topic_loader.detach();

			if (had_old_topic) {
				this.closeActiveTopicView();
			}
			this.$topic.empty();
			/**
			 * If no feed focus, then we hide the topic window and turn off the 'close
			 *  the topic if we click outside the feed' action.
			 */
			if (_.isNull(topic)) {
				this.$topic.hide();
				$("body").off("mousedown.feed");
			}
		},

		throwTopicBlocker: function () {
			this.cleanTopicWindow();
			this.openTopicWindow();
			this.$topic.append(this.$topic_loader);
		},

		openTopicWindow: function () {
			var self = this;
			this.$topic.show();
			if (!this.$topic.data("draggable")) {
				this.$topic.is_dragged = false;
				this.$topic.draggable({
					containment: "window",
					drag: function () {
						self.$topic.is_dragged = true;
					},
				});
			}
		},

		/**
		 * Whenever the feed's focus topic changes, this function does the heavy lifting.
		 *  It closes out the old topic, makes sure the 'body' click action is correct,
		 *  and builds the new topic (if there is one -- this function fires even when
		 *  the focus_topic is set to null, thereby cleaning out the old topic).
		 **/
		buildTopic: function () {
			var topic_view,
				build_options,
				self = this,
				rebuild = false,
				had_old_topic = !_.isNull(this.active_topic_view),
				topic = this.model.get("focus_topic");

			this.cleanTopicWindow();
			/*if (!this.feed_open) {
				RR left this in case we want to change how the preload topics are working--
				we may not want buildTopic executing with feed_open set to false.
				return;
			}*/

			if (_.isNull(topic)) {
				return;
			}

			/**
			 * Check if we have opened this topic before
			 */
			topic_view = _.find(this.topic_views, function (view) {
				return view.model === topic;
			});

			build_options = {
				model: topic,
				route_category_id: topic.get("category_id"),
				reveal_type: this.model.get("focus_topic_show_from"),
			};

			if (!_.isUndefined(topic_view)) {
				if (topic_view.route_category_id !== topic.get("category_id")) {
					// Topic moved.  Build a new window.
					this.topic_views = _.without(this.topic_views, topic_view);
					topic_view.close();
					rebuild = true;
				}
			}

			/**
			 * Build the topic's view if not opened before.
			 */
			if (_.isUndefined(topic_view) || rebuild) {
				topic_view = new FeedViews.TopicFull(build_options);
				this.topic_views.push(topic_view);
			}

			this.active_topic_view = topic_view;
			this.openTopicWindow();

			// Maybe someday.
			//this.$topic.resizable({ handles : 'n, e, s, w'});
			//
			/**
			 * If there wasn't an old topic, then we need to set the click action
			 *  outside the feed to close the feed.
			 */
			if (!had_old_topic) {
				$("body").on("mousedown.feed", function () {
					if (!AoPS.Ui.Modal.isModalVisible()) {
						if (!_.isNull(self.model.get("focus_topic"))) {
							self.past_topic_id = self.model
								.get("focus_topic")
								.get("topic_id");
						}
						self.model.set("focus_topic", null);
					}
				});
			}
			this.$topic.append(this.active_topic_view.$el);
			this.active_topic_view.onAddToFeed(build_options);
		},

		/**
		 * START Page Subfeed methods
		 **/

		/**
		 * What we do when the Feed model's page_subfeed_settings change.
		 */
		onNewPageSubfeed: function () {
			if (!this.has_page_feed) {
				this.constructPageSubfeed();
			}
			this.setPageSubfeed();

			// We only want the new page subfeed marked with new topic
			//  if there are unread topics in this new page subfeed.  Clear
			//  new-topic that might be there from previous page feed and light up
			//  the button if there are unread topics here.
			this.page_subfeed.$button.removeClass("feed-subfeed-new-topic");
			if (this.page_subfeed.view.hasOwnProperty("topics_list_view")) {
				if (
					!_.isUndefined(
						this.page_subfeed.view.topics_list_view.collection.findWhere({
							is_read: false,
						})
					)
				) {
					this.page_subfeed.$button.addClass("feed-subfeed-new-topic");
				}
			}
		},

		/**
		 * Perform the initial construction of the Page Subfeed - build
		 *	its button and the loader we'll put up if we have to build
		 *	something on the fly to fill the page feed.
		 *  Finally, add the page feed to the subfeeds array.
		 ***/
		constructPageSubfeed: function () {
			var self = this;
			this.page_subfeed = {
				$button: $("<div>", {
					id: "feed-page-tab",
					class: "feed-tab aops-font",
					text: "p",
					title: Lang["feed-tab-page-feed-title"],
				}),
			};

			this.page_subfeed.$button.on("click", function () {
				self.onButtonClick(self.page_subfeed);
			});

			//Assumes we always have the global feed.
			this.$tabs.find(".feed-tab").first().after(this.page_subfeed.$button);
			this.subfeeds.push(this.page_subfeed);
			this.page_subfeed_settings = {
				category_id: 0,
				tag_id: 0,
				tag_text: "",
			};

			this.page_subfeed_loader = this.constructPageSubfeedView(
				null,
				this.page_subfeed_settings
			);
			this.page_subfeed.view = this.page_subfeed_loader;
			this.has_page_feed = true;
		},

		/**
		 * The Subfeed View of the PageSubfeed can change during a visit.  For example,
		 *  there might be multiple items on a page with attached conversations.
		 *  We handle this by making different Subfeed Views for each of these.
		 *  This methods creates one and adds it to a cache.
		 *
		 * Each Page Subfeed View has an associated category (Models.Category or child).
		 *
		 * @param ComModels.Category or child of the category that is used for this
		 *				subfeed.
		 * @param settings object
		 *			category_id int required.
		 *			tag_id int optional
		 */
		constructPageSubfeedView: function (category, settings) {
			var $el,
				subfeed_settings_base = {
					header_text: Lang["feed-page-subfeed-header"],
					can_post: false,
					can_post_title: "",
					re_sort_feed: Lang["feed-resort"],
					close_feed: Lang["feed-close"],
					has_settings: false, // HERE is where to add the turtle
				};
			var subfeed_view;

			if (_.isNull(category)) {
				$el = $('<div class="cmty-subfeed"></div>').append(
					this.getTemplate("#feed-subfeed-header-tpl", subfeed_settings_base)
				);

				$el.append(AoPS.Page.buildLoader());
				subfeed_view = {
					$el: $el,
					stopListening: function () {}, //So we don't trip up the listener removers
				};
			} else {
				subfeed_view = new FeedViews.Subfeed(
					_.defaults(
						{
							model: category,
							tag_id: settings.tag_id,
							subtitle: settings.hasOwnProperty("subtitle")
								? settings.subtitle
								: "",
						},
						subfeed_settings_base
					)
				);

				if (
					!subfeed_view.filtered_list.topics_loading &&
					subfeed_view.topics_list_view.collection.length === 0
				) {
					// On 7/31, RR changed this from filtered_list.fetchMoreTopics() to the below.
					//   I think we need to be calling this on the view to get the "no more topics" to show up.
					subfeed_view.topics_list_view.fetchMoreTopics();
				}

				this.cachePageSubfeedView(subfeed_view, settings);
			}

			return subfeed_view;
		},

		/**
		 * We cache the page subfeed views both based on their settings and based on
		 *  other settings that should map to the same view.
		 * The initial caching should always have the tag_id and the tag_text.
		 *	We cache it under just the tag_id and just tag_text, for later fetches
		 *  by just one or the other.
		 ***/
		cachePageSubfeedView: function (subfeed_view, settings) {
			var tag_text = AoPS.Community.Views.convertToUrlFragment(
				settings.tag_text
			);

			this.cached_page_subfeed_views[
				settings.category_id + "-" + settings.tag_id + "-" + tag_text
			] = subfeed_view;
			if (tag_text.length > 0 && settings.tag_id > 0) {
				this.cached_page_subfeed_views[
					settings.category_id + "-0-" + tag_text
				] = subfeed_view;
				this.cached_page_subfeed_views[
					settings.category_id + settings.tag_id + "-"
				] = subfeed_view;
			}
		},

		/**
		 * Set the page subfeed based on the current Feed model's page_subfeed_settings.
		 *
		 * Does not open the subfeed; just changes the Page Subfeed's Subfeed View
		 *  to match the settings.
		 */
		setPageSubfeed: function () {
			var category,
				subfeed_view,
				self = this,
				new_settings;
			// See if we really have a change.
			if (!this.isNewPageSubfeed()) {
				return;
			}

			// Clean out the old Subfeed View's listeners.
			this.removeSubfeedListeners(this.page_subfeed);

			if (this.page_subfeed.view.hasOwnProperty("$el")) {
				this.page_subfeed.view.$el.detach();
			}

			new_settings = this.cleanPageSubfeedSettings(
				this.model.get("page_subfeed_settings")
			);
			subfeed_view = this.fetchCachedPageSubfeed(new_settings);

			if (_.isNull(subfeed_view)) {
				// Have to build the new feed.

				category = this.community_master.fetchCategory(
					new_settings.category_id
				);
				if (_.isUndefined(category)) {
					// If the category isn't loaded, then we have to do that
					//  before we do anything else.
					// Put up the loader...
					this.page_subfeed.view = this.page_subfeed_loader;

					/**
					 * If we have the tag id or if there is no tag set, then we just need
					 *  the category.
					 *
					 * Otherwise, we need to fetch the tag_id, too, sigh.
					 */
					if (new_settings.tag_id > 0 || new_settings.tag_text === "") {
						this.community_master.buildCategory({
							category_id: new_settings.category_id,
							onFinish: function () {
								// We have the new category now, let's start over.
								self.setPageSubfeed();
							},
						});
					} else {
						this.community_master.buildCategoryAndTag({
							category_id: new_settings.category_id,
							tag_text: new_settings.tag_text,
							onFinish: function (data) {
								new_settings.tag_id = data.tag_id;
								self.model.set("page_subfeed_settings", new_settings);
							},
						});
					}
				} else {
					if (new_settings.tag_id === 0 && new_settings.tag_text !== "") {
						// Have a tag, but not its id...
						this.community_master.fetchTagId({
							tag_text: new_settings.tag_text,
							onFinish: function (data) {
								new_settings.tag_id = data.tag_id;
								self.model.set("page_subfeed_settings", new_settings);
							},
						});
					} else {
						// Build the new Subfeed View
						this.page_subfeed.view = this.constructPageSubfeedView(
							category,
							new_settings
						);
					}
				}
			} else {
				// Use the cached Subfeed View
				this.page_subfeed.view = subfeed_view;

				// On /feed/<topic_id>/<route> links, we have to set the feed before getting to
				//  whatever on the <route> might set the subtitle.  So, we stick a subtitle in.
				//  If we later navigate to this page_subfeed by clicking the appropriate spot on
				//  the page, then we want to have the appropriate subtitle.  Here's where we set it.
				//  Main minus is that this gets called all the time, but it gives us the flexibility
				//  for changing subtitles without rebuilding the page feed.
				AoPS.Feed.setPageFeedSubtitle(
					new_settings.hasOwnProperty("subtitle") ? new_settings.subtitle : ""
				);
			}

			this.addSubfeedListeners(this.page_subfeed);
			// If the Page Subfeed is open, then we need to get this on the screen now.
			if (this.active_subfeed === this.page_subfeed) {
				this.revealSubfeedView(this.page_subfeed);
			}
		},

		isPageSubfeedOpen: function () {
			return this.feed_open && this.isPageSubfeedActive();
		},

		isPageSubfeedActive: function () {
			return this.active_subfeed === this.page_subfeed;
		},

		/**
		 * Activate the Page Subfeed
		 **/
		activatePageSubfeed: function () {
			if (this.feed_open) {
				if (!this.isPageSubfeedActive()) {
					if (!_.isNull(this.active_subfeed)) {
						this.closeSubfeed(this.active_subfeed);
					}
				}
				this.activateSubfeed(this.page_subfeed, 0);
			} else {
				this.openFeed(this.page_subfeed);
			}
		},

		/**
		 * Check if the page_subfeed_settings of the Feed model differs from the
		 *  current settings on the Page Subfeed
		 */
		isNewPageSubfeed: function () {
			var new_settings = this.cleanPageSubfeedSettings(
					this.model.get("page_subfeed_settings")
				),
				old_settings = this.cleanPageSubfeedSettings(
					this.page_subfeed_settings
				);

			if (new_settings.category_id !== old_settings.category_id) {
				return true;
			}
			if (new_settings.tag_id === 0 && old_settings.tag_id > 0) {
				if (new_settings.tag_text === old_settings.tag_text) {
					this.model.get("page_subfeed_settings").tag_id = old_settings.tag_id;
				}
			}

			if (new_settings.tag_id === 0 || old_settings.tag_id) {
				return new_settings.tag_text !== old_settings.tag_text;
			} else {
				return new_settings.tag_id !== old_settings.tag_id;
			}
		},

		/**
		 * Fill in a Page Subfeed's settings with defaults.
		 **/
		cleanPageSubfeedSettings: function (settings) {
			return _.extend(
				{
					category_id: 0,
					tag_id: 0,
					tag_text: "",
				},
				settings
			);
		},

		/**
		 * Fetch a cached Page Subfeed View
		 *
		 * @param obj
		 *		category_id int
		 *		tag_id int
		 *		tag_text string
		 **/
		fetchCachedPageSubfeed: function (settings) {
			var tag_text = AoPS.Community.Views.convertToUrlFragment(
					settings.tag_text
				),
				property = settings.category_id + "-" + settings.tag_id + "-";

			/**
			 * If the tag_id is not 0, we need to check category-tag-text and category-tag-
			 **/
			if (settings.tag_id !== 0) {
				if (this.cached_page_subfeed_views.hasOwnProperty(property)) {
					return this.cached_page_subfeed_views[property];
				}
				property += tag_text;
				if (this.cached_page_subfeed_views.hasOwnProperty(property)) {
					return this.cached_page_subfeed_views[property];
				}
			}

			/**
			 * If the tag_id is 0, we still need to check category-0-text
			 **/
			property = settings.category_id + "-0-" + tag_text;

			if (this.cached_page_subfeed_views.hasOwnProperty(property)) {
				return this.cached_page_subfeed_views[property];
			} else {
				return null;
			}
		},

		/**
		 * END Page Subfeed methods
		 **/

		/**
		 * Clean up when we close this view.
		 */
		onClose: function () {
			_.each(this.subfeeds, function (subfeed) {
				subfeed.view.close();
			});

			_.each(
				_.properties(this.cached_page_subfeed_views),
				function (page_subfeed_view) {
					page_subfeed_view.close();
				}
			);
		},
	});

	FeedViews.Subfeed = AoPS.View.extend({
		className: "cmty-subfeed",

		initialize: function (options) {
			var category,
				has_subtitle = options.subtitle && options.subtitle.length > 0,
				tag_ids =
					options.hasOwnProperty("tag_id") && options.tag_id > 0
						? [
								{
									tag_forum_id: this.model.get("category_id"),
									tag_id: options.tag_id,
								},
						  ]
						: [];
			this.settings = options;
			this.community_master = this.model.get("master");
			/**
			 * Some real slight of hand here.  Some page feeds consist of a
			 *  single tag.  In order to get that feed to work
			 *  correctly, we create a CategoryViewTags with that tag as its only
			 *  item.  This only happens when we send in a tag_id to the Subfeed.
			 *
			 * I still can't believe this worked.
			 **/
			if (tag_ids.length > 0) {
				category = new AoPS.Community.Models.CategoryViewTags({
					category_id: 0,
					master: this.community_master,
					permissions: this.model.get("permissions"),
					category_type: "view_tags",
					items: [
						{
							item_forum_id: tag_ids[0].tag_forum_id,
							item_id: tag_ids[0].tag_id,
						},
					],
				});

				var category_topics = category.get("active_topics");
				this.model.get("active_topics").each(function (topic) {
					if (topic.hasTag(options.tag_id)) {
						category_topics.add(topic);
					}
				});
				if (AoPS.Feed.preload_feed_tag_id > 0) {
					if (
						AoPS.Feed.preload_feed_tag_id === options.tag_id &&
						!_.isNull(AoPS.Feed.preloaded_topic)
					) {
						var preloaded_topics =
							this.community_master.processPotentialNewTopics(
								AoPS.bootstrap_data.page_feed_preload_topics,
								false
							);
						category_topics.add(preloaded_topics);
						category.set(
							"all_topics_loaded",
							AoPS.bootstrap_data.page_feed_all_topics_fetched
						);
					}
				}

				this.filtered_list = this.community_master.fetchFilteredTopicList({
					category: category,
					category_id: 0,
				});
			} else {
				this.filtered_list = this.community_master.fetchFilteredTopicList({
					category: this.model,
					category_id: this.model.get("category_id"),
					tag_ids: tag_ids,
				});
			}

			this.topics_list_view = new FeedViews.TopicsList({
				collection: this.filtered_list,
				main_color: this.model.get("main_color"),
				secondary_color: this.model.get("secondary_color"),
				category_id: 0, // This is wrong; Only used for setting routes,
				// which we will do differently.  May just remove this
				master: this.community_master,
			});

			this.$el.append(
				this.getTemplate("#feed-subfeed-header-tpl", {
					header_text: options.header_text,
					can_post: options.hasOwnProperty("can_post")
						? options.can_post
						: false,
					can_post_title: options.hasOwnProperty("can_post_title")
						? options.can_post_title
						: "",
					has_settings: false, // HERE is where to add the turtle
					has_subtitle: has_subtitle,
					close_feed: Lang["feed-close"],
					re_sort_feed: Lang["feed-re-sort"],
					subtitle: options.hasOwnProperty("subtitle") ? options.subtitle : "",
				})
			);

			if (has_subtitle) {
				this.$el.addClass("cmty-subfeed-w-subtitle");
			}

			this.$el.append(this.topics_list_view.$el);
		},

		events: {
			"click .feed-new-topic": "onClickNewTopic",
		},

		onClickNewTopic: function (e) {
			if (!AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
			} else if (!AoPS.in_academy && AoPS.isUserLimited()) {
				AoPS.Ui.Modal.showMessage(Lang["cat-cell-no-perm-limited-user"], {
					width: "450px",
				});
			} else if (this.settings.hasOwnProperty("onClickNewTopic")) {
				this.settings.onClickNewTopic();
			}
			e.stopPropagation();
			e.preventDefault();
			return false;
		},

		onClose: function () {
			this.topics_list_view.close();
		},
	});

	/**
	 * View for the Bookmarks subfeed.
	 *
	 * We build all the possible bookmarks subfeeds here.  We build all 7 at initialization,
	 *  but don't load them.  Another possible approach is to build them
	 *  on-demand.  This would require some re-working below, but is certainly feasible.
	 *
	 * model : AoPS.Community.Models.Feed
	 **/
	FeedViews.Bookmarks = AoPS.View.extend({
		subfeed_array: [], // Array of subfeed views for bookmark combinations

		template_id: "#feed-bookmarks-tpl",

		className: "cmty-subfeed cmty-subfeed-w-subtitle",

		initialize: function (options) {
			var i,
				self = this,
				category_array;

			this.parent_subfeed_object = options.parent_subfeed_object;
			this.feed_view = options.feed_view;
			this.feed_bookmark_categories = [];

			this.$el.html(
				this.getTemplate("#feed-subfeed-header-tpl", {
					header_text: Lang["feed-bookmarks-subfeed-header"],
					has_settings: false, // here is where to add the turtle
				})
			);

			this.$el.append(
				this.getTemplate(this.template_id, {
					forums_checked: this.model.get("feed_setting") & 1,
					tags_checked: this.model.get("feed_setting") & 2,
					topics_checked: this.model.get("feed_setting") & 4,
				})
			);
			this.$checkboxes = this.$el.find(":checkbox");
			//this.$topics_list = this.$el.find('#feed-bookmark-topics');
			this.community_master = this.model.get("master");

			// Tags
			this.feed_bookmark_categories[1] = this.buildFeedCategory("tag");

			//topics
			this.feed_bookmark_categories[2] = this.buildFeedCategory("topic");

			//forums
			this.feed_bookmark_categories[4] = this.buildFeedCategory("forum");
			// Build the category conglomerations for combinations of categories.
			for (i = 3; i <= 7; i++) {
				if (i !== 4) {
					category_array = [];
					_.each([1, 2, 4], function (index) {
						if (index & i) {
							category_array.push(self.feed_bookmark_categories[index]);
						}
					});
					this.feed_bookmark_categories[i] =
						new AoPS.Community.Models.CategoryConglomeration({
							master: this.community_master,
							categories: category_array,
						});
				}
			}
			this.subfeed_array[0] = {
				is_built: true,
				topics_list_view: {
					$el: $(
						'<div class="feed-no-bookmarks">' +
							Lang["feed-no-bookmark-options-checked"] +
							"</div>"
					),
					no_bookmarks_checked: true,
				},
			};

			// We build the subfeeds on demand.  Here, we initialize them as empty.
			for (i = 1; i <= 7; i++) {
				this.subfeed_array[i] = {
					is_built: false,
				};
			}
			this.constructTopicsListView(this.model.get("feed_setting"));
			this.active_subfeed = this.subfeed_array[this.model.get("feed_setting")];
			this.$el.append(this.active_subfeed.topics_list_view.$el);

			this.topics_list_view = this.active_subfeed.topics_list_view;

			//	this.listenTo(this.model, 'change:feed_setting', this.onBookmarkSettingChange);
			if (this.model.get("feed_setting") > 0) {
				this.startListeningToActiveList();
			}
		},

		/**
		 * Construct the TopicsList View for a particular bookmark setting
		 *
		 * @param int bookmark setting (1-7)
		 */
		constructTopicsListView: function (i) {
			var topic_list_model, filter;
			filter = this.community_master.constructTopicListFilter({
				category: this.feed_bookmark_categories[i],
			});
			topic_list_model = new AoPS.Community.Models.TopicList({
				category: this.feed_bookmark_categories[i],
				master: this.community_master,
				tag_ids: [],
				filter: filter,
			});

			this.subfeed_array[i].filtered_list = topic_list_model.get(
				"filtered_topic_list"
			);

			this.subfeed_array[i].topics_list_view =
				new FeedViews.TopicsListBookmarks({
					collection: this.subfeed_array[i].filtered_list,
					main_color: this.feed_bookmark_categories[i].get("main_color"),
					secondary_color:
						this.feed_bookmark_categories[i].get("secondary_color"),
					category_id: 0, // This is probably unnecessary; Only used for setting routes,
					// which we will do differently.  May just remove this
					master: this.community_master,
				});
			this.subfeed_array[i].is_built = true;
		},

		events: {
			"click :checkbox": "onCheckboxClick",
		},

		onCheckboxClick: function (e) {
			var total = 0,
				checkboxes = this.$checkboxes;

			for (var i = 0; i <= 2; i++) {
				if (checkboxes[i].checked) {
					total += parseInt(checkboxes[i].value);
				}
			}
			this.model.set("feed_setting", total);
			this.onBookmarkSettingChange();
		},

		onBookmarkSettingChange: function () {
			var new_setting = this.model.get("feed_setting");
			this.$(".feed-resort").hide();
			/** Stop listening to the subfeed we are leaving **/
			this.stopListening(this.active_subfeed.filtered_list);
			this.active_subfeed.topics_list_view.on_page = false;
			this.active_subfeed.topics_list_view.$el.detach();

			if (
				!this.active_subfeed.topics_list_view.hasOwnProperty(
					"no_bookmarks_checked"
				) ||
				!this.active_subfeed.topics_list_view.no_bookmarks_checked
			) {
				this.active_subfeed.topics_list_view.processUpdatedTopicVisibility();
				this.model.set("focus_topic", null);
			}
			if (!this.subfeed_array[new_setting].is_built) {
				this.constructTopicsListView(new_setting);
			}
			this.active_subfeed = this.subfeed_array[new_setting];

			if (new_setting > 0) {
				if (this.active_subfeed.filtered_list.category.hasItems()) {
					// onSliderAtBottom was here before.
					this.active_subfeed.topics_list_view.onAddToFeed();
				} else {
					this.active_subfeed.topics_list_view.on_page = true;
					this.active_subfeed.topics_list_view.appendNoMoreTopicsMessage();
				}
			}
			this.$el.append(this.active_subfeed.topics_list_view.$el);
			this.topics_list_view = this.active_subfeed.topics_list_view;
			if (new_setting > 0) {
				this.startListeningToActiveList();
			}
		},

		/**
		 * Listen to the active list; on add, if this list is not open in the feed,
		 *  then mark the whole bookmark subfeed's button as having a new topic.
		 **/
		startListeningToActiveList: function () {
			var self = this;

			this.listenTo(this.active_subfeed.filtered_list, "add", function (topic) {
				if (self.feed_view.active_subfeed === self.parent_subfeed_object) {
					return;
				}
				if (!topic.get("is_read")) {
					self.parent_subfeed_object.$button.addClass("feed-subfeed-new-topic");
				}
			});

			this.listenTo(
				this.active_subfeed.filtered_list,
				"change:is_read",
				function (topic) {
					AoPS.Feed.Views.processFeedTopicIsReadChange({
						topic: topic,
						list: self.active_subfeed.filtered_list,
						$button: self.parent_subfeed_object.$button,
					});
				}
			);
		},

		/**
		 * Build a feed category by filtering a bookmark category.
		 *
		 * This is where we strip out the items that are bookmarked, but
		 *  not added to the feed.
		 *
		 * @param string bookmark/feed type
		 */
		buildFeedCategory: function (type) {
			var bookmark_cat = this.community_master.get(
					"bookmarked_" + type + "_category"
				),
				feed_cat,
				constructor_object,
				cat_type;

			if (type === "topic") {
				cat_type = "feed_topics";
			} else {
				cat_type = "view_" + type + "s";
			}

			constructor_object = {
				category_type: cat_type,
				items: _.filter(bookmark_cat.get("items"), function (item) {
					return item.hasOwnProperty("in_feed") && item.in_feed === 1;
				}),
			};

			if (type === "topic") {
				constructor_object.bookmark_topic_category_id = this.community_master
					.get("bookmarked_topic_category")
					.get("category_id");
			}

			feed_cat = this.community_master.constructNewCategory(constructor_object);

			feed_cat.listenTo(
				bookmark_cat,
				"item_added",
				_.bind(function (item) {
					if (item.in_feed) {
						this.addItem(item);
					}
				}, feed_cat)
			);

			feed_cat.listenTo(
				bookmark_cat,
				"item_removed",
				_.bind(function (item) {
					if (item.in_feed) {
						this.removeItem(item);
					}
				}, feed_cat)
			);

			return feed_cat;
		},
	});

	/**
	 * Full topic in the feed.
	 *
	 * model : AoPS.Community.Models.Topic
	 *
	 * Properties defined here
	 * feed : AoPS.Community.Models.Feed of the feed.
	 *
	 * Properties used here, defined in Community.Views.TopicFull (parent).
	 * reveal_type string : show_from_start or show_from_end
	 **/
	FeedViews.TopicFull = AoPS.Community.Views.TopicFull.extend({
		template_id: "#feed-topic-full-tpl",

		viewing_source: "feed",

		scrollbar_settings: {
			autosize: false,
		},

		initialize: function (build_options) {
			this.feed = this.model.get("master").get("feed");
			AoPS.Community.Views.TopicFull.prototype.initialize.apply(this, [
				build_options,
			]);
		},

		/**
		 * What we do when we click close.
		 */
		onClickClose: function (e) {
			this.feed.set("focus_topic", null);
			// This assumes that we are turning off fullscreen when you close a topic.
			this.fullscreen_triggered_by_reply = false;
			this.model.get("master").set("fullscreen_mode", "none");
			this.is_full_reply = false;
			$(window).trigger("resize");

			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * What we do whenever we fire this up in the feed.
		 **/
		onAddToFeed: function (options) {
			this.onAddToPage(options);
		},

		onDelete: function () {
			var deleted_by_me =
				arguments.length > 1 &&
				arguments[2].hasOwnProperty("deleted_by_me") &&
				arguments[2].deleted_by_me;

			if (
				this.model.get("deleted") &&
				this.feed.get("focus_topic") === this.model
			) {
				if (!deleted_by_me) {
					AoPS.Ui.Modal.showAlert(Lang["feed-topic-full-message-deleted"]);
				} else {
					AoPS.Ui.Modal.closeAllModals();
				}
				this.close();
				this.feed.set("focus_topic", null);
			}
		},

		// All replies in the feed are quick.
		onClickFullReply: function () {
			if (this.model.get("master").get("fullscreen_mode") === "feed") {
				this.completeReplyClick("full");
				//				AoPS.Community.Views.TopicFull.prototype.onClickFullReply.apply(this);
			} else {
				this.onClickReply();
			}
		},

		onClickFullScreen: function () {
			this.performFullScreenEvents(false);
		},

		performFullScreenEvents: function (triggered_by_reply) {
			var trigger_event,
				new_fullscreen_mode =
					this.model.get("master").get("fullscreen_mode") === "none"
						? "feed"
						: "none";

			this.model.get("master").set("fullscreen_mode", new_fullscreen_mode);

			if (this.model.get("master").get("fullscreen_mode") === "none") {
				this.is_full_reply = false;
				AoPS.Community.Views.removeFullReplyStyle();
			} else {
				this.is_full_reply = true;
				AoPS.Community.Views.setFullReplyStyle();
			}
			this.model.get("master").get("feed").trigger(trigger_event);
			$(window).trigger("resize");

			//this.setHeight();
		},
		/*
		performFullScreenEvents : function (triggered_by_reply) {
			var anchor_at_bottom = false,
				current_fullscreen_mode = this.model.get('master').get('fullscreen_mode');

			// Check if near bottom before changing
		//	if (!$('body').hasClass('fullscreen')) {
				if (this.$posts_box.height() - this.$posts_inner_wrapper.scrollTop() -
				this.$posts_inner_wrapper.height() < Constants.reply_jump_to_bottom_window) {
					anchor_at_bottom = true;
				}
		//	}

			$('body').toggleClass('fullscreen', !current_fullscreen_mode);
			if (!triggered_by_reply) {
				this.model.get('master').set('fullscreen_mode', !current_fullscreen_mode);
			}

			$(window).trigger('resize');

			if (anchor_at_bottom) {
				this.goToLastPost();
			}
		},*/

		/**
		 * Initialization steps for a TopicFull that are only
		 *  needed in the feed.
		 */
		doExtraInitialization: function () {
			this.$el.find(".feed-topic-forum").css({
				"background-color": this.model.get("category_main_color"),
				color: this.model.get("category_secondary_color"),
			});
			this.$category_top = this.$el.find(".feed-topic-forum");
			this.listenTo(
				this.feed,
				"change:focus_topic_show_from change:focus_topic",
				this.parseFeedFocusChange
			);
		},

		/**
		 * Whenever the feed's focus changes or the show_from changes
		 *  on the focus, we check if it's this TopicFull that is affected.
		 */
		parseFeedFocusChange: function () {
			if (this.model === this.feed.get("focus_topic")) {
				this.reveal_type = this.feed.get("focus_topic_show_from");
				this.setInitialPostBoxLocation();
			}
		},

		/**
		 * In the feed, we only have 'active' PMs, no archived.  So, we only need
		 *  the button for archiving.
		 **/
		setArchiveStatus: function () {
			if (!this.hasOwnProperty(this.$archive_status)) {
				this.$archive_status = $(
					'<span class="cmty-topic-archive clickable"></span>'
				);
				this.$(".cmty-topic-bookmark").replaceWith(this.$archive_status);
			}
			this.$archive_status.append('<span class="aops-icon">(</span>');
			this.$archive_status[0].title = Lang["private-archive-topic"];
		},

		/**
		 * If my Participant status changes, then the focus_topic is set to null.  That will
		 *  close the topic window.
		 **/
		completeParticipantStatusChange: function () {
			var master = this.model.get("master");
			this.feed.set("focus_topic", null);
			master.get("my_privates").trigger("check_for_more_topics");
		},

		/**
		 * Set height of posts window based on height of other stuff
		 */
		/*	RR Removed 3/15/15
		Hopefully I won't have to bring it back
		setHeight : function () {
			if (!this.hasOwnProperty('$top_panel')) {
				return;
			}
			if (this.hasOwnProperty('$posts_outer_wrapper')) {
				if ((this.model.get('master').get('fullscreen_mode') !== 'feed') || ($(window).width() > AoPS.Community.Constants.phone_mode_max_width)) {
					this.$posts_outer_wrapper.outerHeight(this.$posts_outer_wrapper.parent().height() -
						this.$top_panel.outerHeight() -
						this.$bottom_panel.outerHeight());
				} else {
					this.$posts_outer_wrapper.height('');
				}
			}
			return;
		},*/

		onRemoveFromFeed: function () {
			this.onRemoveFromPage();
		},

		/**
		 * Remove the listener for the focus topic.
		 **/
		removeFocusListener: function () {
			this.stopListening(this.feed, "change:focus_topic");
		},

		/**
		 * Set up a listener for changes in the focus topic.  Overwritten in feed.
		 **/
		setFocusListener: function () {
			this.listenTo(this.feed, "change:focus_topic", this.onChangeFocusTopic);
		},

		fetchFocusTopic: function () {
			return this.feed.get("focus_topic");
		},
	});

	/**
	 * Single topic cell in a list of topics in the feed.
	 *
	 * model : AoPS.Community.Models.Topic
	 *
	 * Properties used/defined here
	 * full_topics_popup boolean: tells template not to make this a link, since a
	 *  	popup will hold the topic if this is clicked.
	 */
	FeedViews.TopicCell = AoPS.Community.Views.TopicCell.extend({
		full_topics_popup: true,

		in_feed: true,

		events: {
			click: "onClickTopic",
			"click .cmty-topic-cell-jump-to-bottom": "onClickJumpToBottom",
			"click .cmty-topic-cell-close-topic": "onClickClose",
			"click .cmty-topic-cell-goto-unread": "onClickGoToUnread",
			"click .cmty-topic-cell-post a": "onClickLinkInCell",
		},

		/**
		 * What happens when we click on the topic and not on the jump to bottom button.
		 *  We set the focus topic and the show_from property, listeners in FeedViews.FeedMaster
		 *  do the rest.
		 */
		onClickTopic: function (e) {
			if (e.ctrlKey || e.metaKey) {
				if (
					this.topic_list.collection.category.get("category_type") ===
					"user_search_topics"
				) {
					this.onClickMyTopicsCell(e);
				} else {
					this.openInNewTab();
				}
				e.stopPropagation();
				return;
			}

			this.master.get("feed").set({
				focus_topic_show_from: "show_from_start",
				focus_topic: this.model,
			});

			e.stopPropagation();
		},

		onClickMyTopicsCell: function (e) {
			var msg,
				self = this;

			msg = Utils.formatString(Lang["feed-my-topics-onclick"], [
				e.ctrlKey ? Lang["control-click"] : Lang["command-click"],
			]);

			AoPS.Ui.Modal.showButtons(
				msg,
				[
					{
						text: Lang["feed-my-topics-open-new"],
						value: 1,
					},
					{
						text: Lang["feed-my-topics-remove"],
						value: 0,
					},
				],
				function (val) {
					if (val === 1) {
						self.openInNewTab();
					} else {
						self.model.setMyStatus({
							status: "removed",
						});
						self.topic_list.collection.remove(self.model);
					}
				},
				{
					width: "450px",
				}
			);
			e.stopPropagation();
		},

		openInNewTab: function () {
			var path_to_topic =
				"/c" + this.model.get("category_id") + "h" + this.model.get("topic_id");
			window.open("/community" + path_to_topic, "_blank");
		},

		onClickLinkInCell: function (e) {
			e.preventDefault();
		},

		onClickClose: function (e) {
			this.master.get("feed").set("focus_topic", null);
			e.stopPropagation();
			return false;
		},

		/**
		 * What happens when we click on the jump-to-bottom button in this topic cell.
		 *  We set the focus topic and the show_from property, listeners in FeedViews.FeedMaster
		 *  do the rest.
		 */
		onClickJumpToBottom: function (e) {
			this.master.get("feed").set({
				focus_topic_show_from: "show_from_end",
				focus_topic: this.model,
			});
			e.stopPropagation();
			e.preventDefault();
		},

		onClickGoToUnread: function (e) {
			this.master.get("feed").set({
				focus_topic_show_from: "show_unread",
				focus_topic: this.model,
			});
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * This function is fired on initialization and sets the watcher
		 *  behavior for this topic cell.
		 */
		setFocusWatchBehavior: function () {
			this.listenTo(this.model, "change:is_feed_focus", this.checkFocusTopic);
			//	this.listenTo(this.master.get('feed'), 'change:focus_topic', this.checkFocusTopic);
			this.checkFocusTopic();
		},

		/**
		 * checkFocusTopic checks if this is the focus topic, and
		 *  dresses up this view accordingly.
		 */
		checkFocusTopic: function () {
			/*if (this.is_focus != (this.master.get('feed').get('focus_topic') === this.model)) {
				this.is_focus = !this.is_focus;
				this.processFocusTopicStatusChange();
			}*/
			this.is_focus = this.model.get("is_feed_focus");
			this.processFocusTopicStatusChange();
		},
	});

	/**
	 * View for the popout cell that appears when user scrolls the focused topic offscreen
	 *  in the topic list.
	 **/
	FeedViews.TopicCellPopout = FeedViews.TopicCell.extend({
		parent: FeedViews.TopicCell,

		buildTopic: AoPS.Community.Views.TopicCellPopout.prototype.buildTopic,

		/**
		 * See AoPS.Community.Views.TopicCellPopout.createStuntDouble for documentation for
		 *  what this is all about.
		 *
		 * Add click events to the stunt double in the feed (they are explicit links in the
		 *  main window).
		 **/
		createStuntDouble: function () {
			var self = this;

			AoPS.Community.Views.TopicCellPopout.prototype.createStuntDouble.apply(
				this
			);
			this.$stunt_double
				.find(".cmty-topic-cell-jump-to-bottom")
				.on("click", function (e) {
					self.onClickJumpToBottom(e);
				});
			this.$stunt_double
				.find(".cmty-topic-cell-close-topic")
				.on("click", function (e) {
					self.onClickClose(e);
				});
			this.$stunt_double.on("click", function (e) {
				self.onClickTopic(e);
			});
		},

		constructWatchersLine:
			AoPS.Community.Views.TopicCellPopout.prototype.constructWatchersLine,

		onClose: function () {
			this.$stunt_double.remove();
		},
	});

	/**
	 * List of topics in the feed.
	 */
	FeedViews.TopicsList = AoPS.Community.Views.TopicsList.extend({
		fetch_topics_on_build: false,

		list_location: "feed",

		topicView: FeedViews.TopicCell,

		popoutView: FeedViews.TopicCellPopout,

		onAddToFeed: function () {
			this.on_page = true;
			this.checkQueuedUpTopicBoxes();

			// RR added 4/13/15
			this.parseFocusTopic();

			this.setFocusListener();
			// Previously was onSliderAtBottom
			this.checkMoreTopicsNeeded();
			this.checkIfEnoughCells();
		},

		/**
		 * Set the listener for the focus topic.  Overwrites parent function.
		 */
		setFocusListener: function () {
			this.listenTo(
				this.master.get("feed"),
				"change:focus_topic",
				this.parseFocusTopic
			);
		},

		processUpdatedTopicVisibility:
			AoPS.Community.Views.TopicsList.prototype.processUpdatedTopicVisibility,

		/**
		 * Get the focus topic that's relevant to this list.  Overwrites parent function.
		 */
		getFocusTopic: function () {
			return this.master.get("feed").get("focus_topic");
		},

		/*	onEmptyCollection : function (options) {
			this.constructTopicsList(options);
			if (!this.collection.category.hasItems()) {
				this.$el.html($('#feed-no-bookmarks-tpl').html());
			} else {
				this.constructTopicsList(options);
			}
		}*/
	});

	FeedViews.TopicsListBookmarks = FeedViews.TopicsList.extend({
		initialize: function (options) {
			AoPS.Community.Views.TopicsList.prototype.initialize.apply(this, [
				options,
			]);
			this.$nothing_bookmarked = $(
				'<div class="cmty-no-more-topics">' +
					Lang["topics-list-nothing-bookmarked"] +
					"</div>"
			);
		},

		/**
		 * What we do when the collection for this TopicsList resets.
		 *
		 * Same as all TopicsList, but have to detach the nothing_bookmarked message.
		 **/
		onCollectionReset: function () {
			this.$nothing_bookmarked.detach();
			AoPS.Community.Views.TopicsList.prototype.onCollectionReset.apply(this);
		},

		/**
		 * What we do when we have no more topics to show the user.
		 */
		appendNoMoreTopicsMessage: function () {
			this.$loader.detach();

			if (this.collection.length > 0) {
				// User has some topics bookmarked, so we show no-more-topics
				this.$nothing_bookmarked.detach();
				this.$topics_box.append(this.$no_more_topics);
			} else {
				// Tell the user they have nothing bookmarked.
				this.$no_more_topics.detach();
				this.$topics_box.append(this.$nothing_bookmarked);
			}
		},
	});

	FeedViews.NewTopic = AoPS.Community.Views.NewTopic.extend({
		/**
		 * Here's what we do when we finish a topic.
		 **/
		onPostedNewTopic: function (obj) {
			// Only used in non-community, I believe, but I don't think we can post
			//  non-privates from the feed.

			if (
				obj.topic.has("linked_tag_removed") &&
				obj.topic.get("linked_tag_removed")
			) {
				// Focus topic before activate if going global; reverse order otherwise.
				this.model.get("master").get("feed").set("focus_topic", obj.topic);

				AoPS.Feed.activateGlobalSubfeed();
			} else {
				AoPS.Feed.openPageFeed({
					category_id: this.model.get("category_id"),
					tag_text: this.settings.hasOwnProperty("filter_tag")
						? this.settings.filter_tag
						: this.settings.target_url,
					subtitle: this.settings.hasOwnProperty("subtitle")
						? this.settings.subtitle
						: "",
					force_open: true,
				});
				// Must come after open feed.  Otherwise, the openPageFeed call
				//  will close the topic.  That's dumb.
				this.model.get("master").get("feed").set("focus_topic", obj.topic);
			}

			if (typeof this.settings.onSuccess === "function") {
				this.settings.onSuccess(obj);
			}
		},
	});

	FeedViews.NewPrivateConversation =
		AoPS.Community.Views.NewPrivateConversation.extend({
			/**
			 * Here's what we do when we finish a topic.
			 **/
			onPostedNewTopic: function (obj) {
				var master = this.model.get("master");

				if (
					obj.topic.get("topic_type") === "private" &&
					master.get("current_user").get("pm_archive_on_send")
				) {
					Flyout.display(Lang["new-topic-pm-archived"]);
					return;
				}
				master.get("feed").set("focus_topic", obj.topic);
			},
		});

	return FeedViews;
})(AoPS.Feed.Views || {});
